module.exports = __webpack_public_path__ + "static/media/Supreme Court Seat.49b19612.png";